import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';

if (environment.production) {
  initFederation()
  .catch(err => console.error(err))
  .then(_ => import('./bootstrap.production'))
  .catch(err => console.error(err));
}else{
  import('./bootstrap');
}
